import { useLang } from "../../context/LanguageContext";
import { ArrowUpRight } from "lucide-react";

export const Insights = () => {
  const { t } = useLang();
  return (
    <section id="insights" data-testid="insights-section" className="py-24 lg:py-32 bg-[#F8F9FA] border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.insights.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight">
              {t.insights.title}
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-[#0B1F3A]/70 text-base lg:text-lg leading-relaxed">{t.insights.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {t.insights.items.map((it, i) => (
            <article
              key={i}
              data-testid={`insight-${i}`}
              className="group border border-[#0B1F3A]/15 bg-white p-7 lg:p-8 hover:border-[#D4AF37] transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[#0B1F3A]/60 border border-[#0B1F3A]/15 px-2 py-1">
                  {it.tag}
                </span>
                <span className="text-[10px] tracking-widest text-[#0B1F3A]/40 font-mono">{it.read}</span>
              </div>
              <h3 className="font-display text-lg lg:text-xl text-[#0B1F3A] font-medium leading-snug group-hover:text-[#0B1F3A]">
                {it.title}
              </h3>
              <div className="mt-6 pt-4 border-t border-[#0B1F3A]/10 flex items-center justify-between">
                <span className="text-[11px] uppercase tracking-widest text-[#0B1F3A]/50 font-semibold">MaxSolution Editorial</span>
                <ArrowUpRight size={16} strokeWidth={1.5} className="text-[#0B1F3A]/40 group-hover:text-[#D4AF37] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
